/*
 * @Author: qinzhang14
 * @Date: 2021-11-29 10:23:56
 * @LastEditTime: 2022-04-14 15:51:47
 * @LastEditors: shangao
 * @Description: 
 * @FilePath: \teaching-web\src\main.js
 */
import Vue from 'vue'
import App from './App.vue'
import '@/assets/sso/sso.all.js'; 
import ElementUI from 'element-ui';
import Ahedu from 'ahedu-common'
import 'ahedu-common/lib/ahedu-common.css'
import router from '@/router';
import { store } from '@/store';
import configData from '../public/config/index.json';

import api from '@/services';
import '@/assets/style/common.css';
import 'element-ui/lib/theme-chalk/index.css';
import '@/components'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'

Vue.use(Antd);

Vue.use(ElementUI);
window.APP_CONFIG = configData
Vue.prototype.$api = api;
Vue.config.productionTip = false
 
//Vue.use(Antd)

// 测试环境
// 支持的值为 'test' | 'pre-prod' | 'prod';
//Ahedu.config.env = 'prod'
Ahedu.config.env = 'prod'
Vue.use(Ahedu)

new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')
